import { FolderAlertIcon } from './FolderAlertIcon';

/**
 * author: Michael Irigoyen
 * id D26F1A90-B76E-4C13-A956-2EBA33493563
 * name folder-alert
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-alert.svg
 * tags
 * - Files / Folders 
 * - Alert / Error 
 */
export const FolderWarningIcon = FolderAlertIcon;
export default FolderWarningIcon